<template>
    <h2 class="text-h3 page-subheading">{{ title }}</h2>
</template>

<script>
export default {
    name: 'PageSubheading',
    props: {
        /**
         * Will be used as main content for the component.
         */
        title: String
    }
}
</script>

<style scoped>
.page-subheading {
    font-weight: bold;
    margin-top: 5%;
    margin-bottom: 5%;
    text-align: center;
}
</style>